if (!customElements.get('top-ranking-tabs')) {
  customElements.define(
    'top-ranking-tabs',
    class TopRankingTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('.top-ranking__tab'));
        this.panels = Array.from(this.querySelectorAll('.top-ranking__panel'));
        if (this.tabs.length === 0) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', (event) => {
            event.preventDefault();
            this.activate(index);
          });
          tab.addEventListener('keydown', (event) => {
            const last = this.tabs.length - 1;
            let next = index;
            if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
            else if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = last;
            else return;
            event.preventDefault();
            this.activate(next);
            this.tabs[next].focus();
          });
        });
      }

      activate(index) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
        });
        this.panels.forEach((panel, i) => {
          const active = i === index;
          panel.classList.toggle('is-active', active);
          if (active) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      }
    }
  );
}
